// extracted by mini-css-extract-plugin
export default {"content":"NFXvK","pinnedAppIcon":"LFvJ5"};